
export const state = {
    users:[],
    systemUser:[],
}

export default state


// WEBPACK FOOTER //
// ./src/vuex/modules/users/state.js